import { BsArrowDown, BsArrowUp } from 'react-icons/bs'

type Props = {
  label: string
  desc?: boolean
  type?: 'string' | 'number'
}

function SortAZ() {
  return <span>A-Z</span>
}

function SortZA() {
  return <span>Z-A</span>
}

export function SortingOptionLabel({
  label,
  type = 'string',
  desc = false,
}: Props) {
  let Icon

  if (type === 'number') {
    if (desc) {
      Icon = BsArrowDown
    } else {
      Icon = BsArrowUp
    }
  } else {
    if (desc) {
      Icon = SortZA
    } else {
      Icon = SortAZ
    }
  }

  return (
    <div className="flex gap-4 items-center">
      {label} <Icon />
    </div>
  )
}
